<template>
  <!-- 查询参数（queryType）：高级=条件分组编辑器（监听/固定/上下文 + 运算符 + 固定值）；
       简单=JSON value 条目。port 自 FieldSetting 查询条件配置。 -->
  <a-col :span="24">
    <div class="section-title">
      <span>查询参数</span>
      <a-radio-group
        v-model:value="config.queryType"
        size="small"
      >
        <a-radio-button value="simple">简单查询</a-radio-button>
        <a-radio-button value="advanced">高级查询</a-radio-button>
      </a-radio-group>
      <a-button
        v-if="config.queryType === 'advanced'"
        type="primary"
        size="small"
        @click="addSearchConditions"
      >
        + 添加查询条件分组
      </a-button>
      <a-button
        v-else
        type="primary"
        size="small"
        @click="addSimpleSearchItem"
      >
        + 添加查询条件
      </a-button>
    </div>
  </a-col>

  <!-- 高级查询：条件分组编辑器 -->
  <a-col
    v-if="config.queryType === 'advanced'"
    :span="24"
  >
    <div
      v-for="(group, gi) in config.searchConditions || []"
      :key="gi"
      class="cond-group"
    >
      <div class="group-header">
        <span class="group-title">查询条件组 {{ gi + 1 }}</span>
        <a-space>
          <a-button
            size="small"
            type="link"
            @click="addSearchItem(gi)"
          >
            + 添加查询条件
          </a-button>
          <a-button
            size="small"
            type="link"
            danger
            @click="config.searchConditions.splice(gi, 1)"
          >
            删除分组
          </a-button>
        </a-space>
      </div>
      <div
        v-for="(item, ii) in group"
        :key="ii"
        class="cond-item"
      >
        <div class="cond-row">
          <span class="row-no">({{ ii + 1 }})</span>
          <a-select
            v-model:value="item.searchType"
            style="width: 130px"
            placeholder="查询类型"
            :options="SEARCH_TYPE_OPTIONS"
          />
          <a-input
            v-if="item.searchType === 1 || item.searchType === 4"
            v-model:value="item.select_name"
            style="width: 160px"
            :placeholder="item.searchType === 1 ? '监听字段' : '上下文键'"
          />
          <a-auto-complete
            v-model:value="item.field_name"
            :options="fieldOptions"
            :loading="fieldOptionsLoading"
            style="width: 180px"
            placeholder="查询字段"
            :filter-option="filterOptionContains"
          />
          <a-button
            type="text"
            danger
            @click="group.splice(ii, 1)"
          >
            ✕
          </a-button>
        </div>
        <div class="cond-row">
          <a-select
            v-model:value="item.format"
            style="width: 110px"
            :options="FORMAT_TYPE.map((f) => ({ value: f, label: f }))"
          />
          <a-select
            v-model:value="item.operator"
            style="width: 190px"
            placeholder="判断条件"
            :options="operatorOptions"
            @change="ensureValueShape(item)"
          />
          <a-select
            v-model:value="item.class_name"
            style="width: 110px"
            placeholder="数值类型"
            :options="SEARCH_CLASS_NAME.map((c) => ({ value: c, label: c }))"
            @change="item.value = []"
          />
          <!-- 固定查询才可填值 -->
          <template v-if="item.searchType === 3">
            <template v-if="(item.operator === 'between' || item.operator === 'notbetween') && item.class_name === 'str'">
              <a-input
                v-model:value="item.value[0]"
                style="width: 110px"
                placeholder="起"
              />
              <span class="range-sep">_</span>
              <a-input
                v-model:value="item.value[1]"
                style="width: 110px"
                placeholder="止"
              />
            </template>
            <template v-else-if="(item.operator === 'between' || item.operator === 'notbetween') && item.class_name === 'int'">
              <a-input-number
                v-model:value="item.value[0]"
                style="width: 110px"
                placeholder="起"
              />
              <span class="range-sep">_</span>
              <a-input-number
                v-model:value="item.value[1]"
                style="width: 110px"
                placeholder="止"
              />
            </template>
            <template v-else-if="(item.operator === 'between' || item.operator === 'notbetween') && item.class_name === 'datetime'">
              <a-range-picker
                v-model:value="item.value"
                show-time
                style="width: 260px"
              />
            </template>
            <a-select
              v-else-if="item.class_name === 'bool'"
              v-model:value="item.value[0]"
              style="width: 110px"
              :options="BOOL_OPTIONS"
            />
            <a-input
              v-else-if="item.operator === 'not_blank_not_null'"
              value=""
              style="width: 150px"
              disabled
              placeholder="（无值）"
            />
            <a-input
              v-else
              v-model:value="item.value[0]"
              style="width: 150px"
              placeholder="值"
              allow-clear
            />
          </template>
        </div>
      </div>
    </div>
  </a-col>

  <!-- 简单查询 -->
  <a-col
    v-if="config.queryType === 'simple'"
    :span="24"
  >
    <div class="cond-group">
      <div
        v-for="(item, si) in config.simpleSearchConditions || []"
        :key="si"
        class="cond-item"
      >
        <div class="cond-row">
          <span class="row-no">({{ si + 1 }})</span>
          <a-select
            v-model:value="item.searchType"
            style="width: 130px"
            placeholder="查询类型"
            :options="SEARCH_TYPE_OPTIONS"
          />
          <a-input
            v-if="item.searchType === 1 || item.searchType === 4"
            v-model:value="item.select_name"
            style="width: 170px"
            :placeholder="item.searchType === 1 ? '监听字段' : '上下文键'"
          />
          <a-auto-complete
            v-model:value="item.field_name"
            :options="fieldOptions"
            :loading="fieldOptionsLoading"
            style="width: 180px"
            placeholder="查询字段"
            :filter-option="filterOptionContains"
          />
          <a-button
            type="text"
            danger
            @click="config.simpleSearchConditions.splice(si, 1)"
          >
            ✕
          </a-button>
        </div>
        <div
          v-if="item.searchType === 3"
          class="cond-row"
        >
          <a-textarea
            :value="typeof item.value === 'object' ? JSON.stringify(item.value) : item.value"
            placeholder="请输入值（对象/数组/字符串）"
            :auto-size="{ minRows: 2, maxRows: 6 }"
            style="flex: 1"
            @input="(e: any) => handleTextareaInput(e, item)"
          />
          <a-tag
            v-if="item.value !== '' && item.value != null"
            color="blue"
          >
            {{ getDataType(item.value) }}
          </a-tag>
        </div>
      </div>
    </div>
  </a-col>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import {
  BOOL_OPTIONS,
  DATE_OPS,
  DATE_TYPES,
  FORMAT_TYPE,
  NUMBER_OPS,
  NUMBER_TYPES,
  OPERATOR,
  SEARCH_CLASS_NAME,
  SELECT_LIKE_TYPES,
  SELECT_OPS,
  TEXT_OPS,
} from './constants';

const props = defineProps<{
  config: any;
  fieldOptions: any[]; // 数据源字段候选
  fieldOptionsLoading?: boolean;
}>();

const SEARCH_TYPE_OPTIONS = [
  { value: 1, label: '监听查询' },
  { value: 3, label: '固定查询' },
  { value: 4, label: '上下文' },
];

const filterOptionContains = (input: string, option: any) =>
  !input || (option?.label ?? '').toLowerCase().includes(input.toLowerCase());

/* 运算符候选按组件类型过滤 */
const operatorOptions = computed(() => {
  const t = props.config?.type;
  let ops = TEXT_OPS;
  if (NUMBER_TYPES.includes(t)) ops = NUMBER_OPS;
  else if (DATE_TYPES.includes(t)) ops = DATE_OPS;
  else if (SELECT_LIKE_TYPES.includes(t)) ops = SELECT_OPS;
  return Object.keys(OPERATOR)
    .filter((k) => ops.includes(k))
    .map((k) => ({ value: k, label: `${OPERATOR[k]}(${k})` }));
});

const addSearchConditions = () => {
  if (!Array.isArray(props.config.searchConditions)) props.config.searchConditions = [];
  props.config.searchConditions.push([{ searchType: 3, field_name: '', operator: 'eq', format: 'input', class_name: 'str', value: [] }]);
};
const addSearchItem = (gi: number) => {
  props.config.searchConditions[gi].push({ searchType: 3, field_name: '', operator: 'eq', format: 'input', class_name: 'str', value: [] });
};
/* operator/class_name 变化时保证 value 形状（between 需两位） */
const ensureValueShape = (item: any) => {
  if (item.operator === 'between' || item.operator === 'notbetween') {
    const v0 = Array.isArray(item.value) ? item.value[0] : item.value;
    const v1 = Array.isArray(item.value) ? item.value[1] : undefined;
    item.value = [v0 ?? null, v1 ?? null];
  } else if (!Array.isArray(item.value)) {
    item.value = [item.value];
  } else if (item.value.length > 1) {
    item.value = [item.value[0]];
  }
};

const addSimpleSearchItem = () => {
  if (!Array.isArray(props.config.simpleSearchConditions)) props.config.simpleSearchConditions = [];
  props.config.simpleSearchConditions.push({ searchType: 3, field_name: '', value: '' });
};
const handleTextareaInput = (e: any, item: any) => {
  try {
    item.value = JSON.parse(e.target.value);
  } catch {
    item.value = e.target.value;
  }
};
const getDataType = (value: any) => (typeof value === 'object' ? 'json' : typeof value);
</script>

<style scoped lang="less">
.section-title {
  display: flex;
  align-items: center;
  gap: 12px;
  font-weight: 500;
  margin: 8px 0;
  padding-top: 8px;
  border-top: 1px dashed rgba(0, 0, 0, 0.1);
}
.cond-group {
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 6px;
  padding: 8px;
  margin-bottom: 8px;
}
.group-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 4px;
  .group-title {
    font-weight: 500;
  }
}
.cond-item {
  padding: 4px 0;
  border-top: 1px dashed rgba(0, 0, 0, 0.06);
}
.cond-row {
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 4px 0;
  flex-wrap: wrap;
}
.row-no {
  color: rgba(0, 0, 0, 0.45);
  flex: none;
  width: 28px;
}
.range-sep {
  text-align: center;
}
</style>
